// components/schema/schema-storage.js

const SCHEMAS_KEY = "pgs_saved_schemas"

export const now = () => Date.now()

export const prettyDate = (ts) => new Date(ts).toLocaleString()

export function loadSavedSchemas() {
  if (typeof window === "undefined") return []
  try {
    const raw = localStorage.getItem(SCHEMAS_KEY)
    const arr = raw ? JSON.parse(raw) : []
    return Array.isArray(arr) ? arr : []
  } catch {
    return []
  }
}

export function saveSavedSchemas(arr) {
  if (typeof window === "undefined") return
  try { localStorage.setItem(SCHEMAS_KEY, JSON.stringify(arr)) } catch {}
}

export function upsertSchema(list, { id, name, code }) {
  const ts = now()
  if (id) {
    return list.map(s => (s.id === id ? { ...s, name, code, updatedAt: ts } : s))
  } else {
    const newId = `${ts}_${Math.random().toString(36).slice(2,8)}`
    return [{ id: newId, name, code, createdAt: ts, updatedAt: ts }, ...list]
  }
}

export function dl(text, name) {
  const blob = new Blob([text], { type: "text/plain" })
  const url = URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = url
  a.download = name
  a.click()
  URL.revokeObjectURL(url)
}
